import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { fitNo, fitYes } from '../data/content';
export function FitFor() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-158" data-mp="21u1tg0xjojrp">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-159" data-mp="1wwa3hcggn7q5">
        <SectionHeading eyebrow="Verifica onesta" title="Il Sistema Maestro della TRT™ è adatto a te?" data-id="element-160" data-mp="1wx1vkdaumnbo" />

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-161" data-mp="147mcd0915o4o">
          <div className="rounded-2xl border-2 border-gold-500/40 bg-gold-50/60 p-5 sm:p-6" data-id="element-162" data-mp="1495tet2ig37i">
            <h3 className="text-[13px] font-black uppercase tracking-[0.12em] text-gold-800" data-id="element-163" data-mp="1j6gbwmdkm9cq">
              Sì — se vuoi
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-164" data-mp="2uk0lm571cx0l">
              {fitYes.map(item => <li key={item} className="flex gap-3 text-[14px] font-medium leading-snug text-navy-900" data-id="element-165" data-mp="2um4vr4vj2s9b">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-700" aria-hidden="true" data-id="element-166" data-mp="2t8yp1yogccjv" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-navy-900/10 bg-navy-50 p-5 sm:p-6" data-id="element-167" data-mp="379swadzrk7gy">
            <h3 className="text-[13px] font-black uppercase tracking-[0.12em] text-navy-900/55" data-id="element-168" data-mp="377ghuat7sf8n">
              Non è progettato per
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-169" data-mp="2fjofsqf4k4l0">
              {fitNo.map(item => <li key={item} className="flex gap-3 text-[14px] leading-snug text-navy-900/65" data-id="element-170" data-mp="2jjoso6mks7py">
                  <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-900/40" aria-hidden="true" data-id="element-171" data-mp="2oc89rdkh1kzi" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-172" data-mp="2z4i50bq5ay11">
          <CtaBlock label="Fa per me — voglio accedere" note="Pagamento unico di 19 EUR · Garanzia 7 giorni" data-id="element-173" data-mp="2u6gkdmd2mqng" />
        </div>
      </div>
    </section>;
}